<template>
  <div>
    <v-row no-gutters>
      <v-col>
        {{creators}} ({{publicationYear}}): <span class="mx-1 font-italic">{{title}}</span>({{type}}).
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        {{publisher}},
        <a :href="doiUrl" target="_blank">
          <v-img class="doi-image" src="@/assets/images/doi-logo.svg" max-height="16" max-width="16"/>
          <span class="">{{doi}}</span>
          <meta name="DC.identifier" :content="doiUrl" scheme="DCTERMS.URI">
        </a>.
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DoiCitationComponent',
  props: {
    metadata: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.metadata.titles.map(({ title }) => title).join('; ')
    },
    creators () {
      return this.metadata.creators.map(({ name }) => name).join('; ')
    },
    publicationYear () {
      return this.metadata.publicationYear
    },
    type () {
      return this.metadata.types.resourceTypeGeneral
    },
    publisher () {
      return this.metadata.publisher
    },
    doi () {
      return this.metadata.doi
    },
    doiUrl () {
      return this.metadata.url
    }
  }
}
</script>

<style scoped>
  .doi-image {
    display: inline-block;
    margin: 0 4px -2px 0;
  }
</style>
